import apiClient from "../helpers/apiClient";

export async function getNotificationsRequestWL() {
    const { data } = await apiClient.get('/notifications/');
    return data?.results;
}

export async function readNotification(id: number) {
    const { data } = await apiClient.post(`notifications/${id}/read/`);
    return data?.results;
}

export async function markAllNotificationsRead() {
    const { data } = await apiClient.post('/notifications/mark-all-read/');
    return data;
}

/**
 * DELETE /notifications/{id}/
 *
 * El backend valida ownership; el frontend solo dispara. Un 403/404 llega como
 * axios error y lo captura el consumidor (patron consistente con el resto de
 * services del repo).
 */
export async function deleteNotification(id: number) {
    const { data } = await apiClient.delete(`/notifications/${id}/`);
    return data;
}
